module.exports = __webpack_public_path__ + "media/application/images/2023/shapes/05_shape-md-0db6fce987fbb96da79af75f89b24928.png";